module.exports = __webpack_public_path__ + "img/museu-arte1.1841e905.jpeg";